<template>
  <div>
    <div class="homepage-container">
      <v-card class="homepage-card">
        <v-card-text>
          <div style="align-items: baseline" class="mb-lg-2">
            <div style="text-align: center">
              <img :src="logoUrl" alt="Avatar" style="width: 26vw"><br><span class="homepage app-name-panel"> AVAILABLE SERVICES</span>
              <!--                            <div class="homepage app-name-panel">AVAILABLE ONLINE VISA SERVICES</div>-->
            </div>
            <!--                        <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">-->

            <!--                        </div>-->
          </div>
          <div class="homepage-services">
            <div class="row">
<!--              <div class="col-12 text-center">-->
<!--                <span class="homepage-service-name-panel text-uppercase">Online Visa Services</span>-->
<!--              </div>-->

              <!--              <homepage-item @click.native="selectCard('pre-arrival')"-->
              <!--                             title="Visa Pre-Arrival"-->
              <!--                             service_icon="ic_online.png"-->
              <!--                             sub_title="Before arriving in Nepal"-->
              <!--                             info="Apply for Visa online before arriving in Nepal"-->
              <!--                             redirection_link="/online"-->
              <!--                             :style="selectedCard=='pre-arrival'?styleObject:''">-->
              <!--              </homepage-item>-->

              <v-flex md3 class="pa-2" :style="selectedCard=='on-arrival'?styleObject:''">
                <v-card raised @click="showOfficeDialog('on-arrival')" target="_blank"
                        class="mx-auto">
                  <v-list-item class="py-3">
                    <!--                <v-icon  height="45" :src="service_icon"/>-->
                    <img height="40"
                         :src="require('@/assets/visa-services/ic_visa_on_arrival.png')"/>
                    <v-list-item-content class="ml-4">
                      <v-list-item-title class="headline"><span
                          style="font-size: 17px;color: #0065D8; font-weight: bold">Visa On-arrival</span>
                      </v-list-item-title>
                      <v-list-item-subtitle><span
                          style="font-size: 13px;font-weight: bold; color: #E7492E;">After arriving in Nepal</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item-subtitle class="pl-4 pb-3 pt-1">
                    <v-icon class="">mdi-hand-pointing-right</v-icon>
                    <span style="color: #000000; font-weight: bold; font-style: normal;font-size: 12px;">Apply for Visa at Terminal after arriving in Nepal</span>
                  </v-list-item-subtitle>
                </v-card>
              </v-flex>

              <homepage-item @click.native="selectCard('visa-from-mission')"
                             title="Visa From Nepalese Mission"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Visa application at Diplomatic Mission"
                             info="Apply for Visa at Embassy/Mission/Consulate"
                             info_ii="Compulsory for all travel document holders"
                             redirection_link="/onlinevisa-mission"
                             :style="selectedCard=='visa-from-mission'?styleObject:''"
              ></homepage-item>
                <homepage-item @click.native="selectCard('eta-visa-processing')"
                               title="Electronic Travel Authorization"
                               service_icon="ic_entry_visa.png"
                               sub_title="Visa application for ETA"
                               info="Apply for ETA online before arriving in Nepal"
                               redirection_link="/eta-visa-processing"
                               :style="selectedCard == 'eta-visa-processing' ? styleObject : ''"
                ></homepage-item>
              <homepage-item @click.native="selectCard('visa-extension')"
                             title="Visa Extension"
                             service_icon="ic_visa_extension.png"
                             sub_title="Extending current visa"
                             info="Extend the current visa"
                             redirection_link="/visa-processing?tab=tab-extend"
                             :style="selectedCard=='visa-extension'?styleObject:''"
              ></homepage-item>
            </div>
            <div class="row mt-2">

              <homepage-item @click.native="selectCard('visa-conversion')"
                             title="Visa Conversion"
                             sub_title="Converting to another visa type"
                             info="Convert one type of Visa to another"
                             service_icon="ic_visa_conversion.png"
                             redirection_link="/visa-processing?tab=tab-change"
                             :style="selectedCard=='visa-conversion'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('visa-transfer')"
                             title="Visa Transfer"
                             service_icon="ic_visa_transfer.png"
                             sub_title="Transferring visa to another document"
                             info="Transfer visa to another another passport,td,etc."
                             redirection_link="/visa-processing?tab=tab-transfer"
                             :style="selectedCard=='visa-transfer'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('entry-visa')"
                             title="Entry Visa"
                             service_icon="ic_entry_visa.png"
                             sub_title="Entry Tourist Visa "
                             info="Apply for Entry Tourist Visa"
                             redirection_link="/entry-visa-processing"
                             :style="selectedCard=='entry-visa'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('visa-plan-upgrade')"
                             title="Visa Plan Upgrade"
                             service_icon="ic_plan_upgrade.png"
                             sub_title="Visa Plan Upgrade"
                             info="Upgrade visa plan to SRE/MRE"
                             redirection_link="/visa-processing?tab=tab-upgrade"
                             :style="selectedCard=='visa-plan-upgrade'?styleObject:''"
              ></homepage-item>
            </div>
            <div class="row mt-2">
<!--              <div class="col-12 text-center">-->
<!--                <span class="homepage-service-name-panel text-uppercase">A/D Certification & Application Track</span>-->
<!--              </div>-->

              <homepage-item @click.native="selectCard('arrival-departure')"
                             title="Arrival/Departure Certification"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Arrival/Departure certification"
                             info="Certify for Arrival/Departure"
                             redirection_link="/visa-processing?tab=tab-arrival"
                             :style="selectedCard=='arrival-departure'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('non-visa-arrival-departure')"
                             title="Non Visa Arrival/Departure Certification"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Non Visa Arrival/Departure certification"
                             info="Certify for Non Visa Arrival/Departure"
                             redirection_link="/non-visa-arrival-departure-certification"
                             :style="selectedCard=='non-visa-arrival-departure'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('visa-application-track')"
                             title="Visa Application Track"
                             service_icon="ic_visa_embassy.png"
                             sub_title="To track visa application"
                             info="Track your visa application"
                             redirection_link="/visa-application-track"
                             :style="selectedCard=='visa-application-track'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('visa-check')"
                             title="Check Visa"
                             service_icon="ic_visa_embassy.png"
                             sub_title="To check visa issued by Nepal"
                             info="Check visa issued by Nepal"
                             redirection_link="/visa-check"
                             :style="selectedCard=='visa-check'?styleObject:''"
              ></homepage-item>
            </div>
            <div class="row mt-2">
<!--              <div class="col-12 text-center">-->
<!--                <span class="homepage-service-name-panel text-uppercase">Online Trekking Permit</span>-->
<!--              </div>-->

              <homepage-item @click.native="selectCard('trekking-permit-check')"
                             title="Check Trekking Permit"
                             service_icon="ic_visa_embassy.png"
                             sub_title="To check trekking permit issued by Nepal"
                             info="Check trekking permit issued by Nepal"
                             redirection_link="/permit-check"
                             :style="selectedCard=='trekking-permit-check'?styleObject:''"
              ></homepage-item>

              <homepage-item @click.native="selectCard('trekking-agency')"
                             title="Trekking Agency"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Trekking Agency Portal"
                             info="Apply for Trekking Agency"
                             redirection_link="/trekking"
                             :style="selectedCard=='trekking-agency'?styleObject:''"
              ></homepage-item>
              <homepage-item @click.native="selectCard('single-trekking-permit')"
                             title="Individual Trekking Permit"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Apply for individual trekking permit request"
                             info="Apply for individual trekking permit request"
                             redirection_link="/trekking/single-trekking-request/apply"
                             :style="selectedCard=='single-trekking-permit'?styleObject:''"
              ></homepage-item>
              <homepage-item @click.native="selectCard('official-immigration-site')"
                             title="Department of Immigration"
                             service_icon="ic_online.png"
                             sub_title="Official Website of Immigration Nepal"
                             info="Official Website of Immigration Nepal"
                             redirection_link="https://www.immigration.gov.np/"
                             :style="selectedCard == 'official-immigration-site' ? styleObject: ''"
              ></homepage-item>
            </div>


          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="showDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Choose your entry point</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                      :items="offices"
                      item-text="name"
                      item-value="slug"
                      label="Select Entry Point"
                      v-model="selectedEntryPoint"
                      outlined
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click.stop="showDialog = false;selectedEntryPoint=''">Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <developed-by-item></developed-by-item>
  </div>
</template>

<script>
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "../constant/appConstant";
import DevelopedByItem from "../components/DevelopedBy";
import HomepageItem from "../components/HomepageItem";

export default {
  components: {DevelopedByItem, HomepageItem},
  data() {
    return {
      sarkarLogo: NEPAL_SARKAR_LOGO,
      logoUrl: NEPALIPORT_LOGO_URL,
      showDialog: false,
      selectedEntryPoint: '',
      selectedCard: '',
      styleObject: {}
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchOffices');
  },
  computed: {
    offices() {
      return this.$store.state.Office.offices;
    }
  },
  methods: {
    selectCard(item) {
      this.selectedCard = item;
      this.styleObject = "border-style:solid"
    },
    showOfficeDialog(item) {
      this.selectedCard = item
      this.styleObject = "border-style:solid"
      this.showDialog = true;
    }
  },
  watch: {
    "selectedEntryPoint": function (newValue) {
      if (newValue != '') {
        this.showDialog = false
        window.open('/on-arrival/' + newValue, '_blank')
      }
    }
  }
}
</script>
